import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import AlumnoLayout from "@/components/AlumnoLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import ProgramForum from "@/components/ProgramForum";
import { ChevronLeft } from "lucide-react";

export default function ProgramaForo() {
  const { programId } = useParams();
  const { user } = useAuth();
  const [program, setProgram] = useState(null);

  useEffect(() => {
    api.get(`/alumno/programs/${programId}`)
      .then((r) => setProgram(r.data.program))
      .catch(() => {});
  }, [programId]);

  if (!program) {
    return (
      <AlumnoLayout user={user}>
        <p className="text-gray-400">Cargando…</p>
      </AlumnoLayout>
    );
  }

  return (
    <AlumnoLayout user={user}>
      <div>
        <Link
          to={`/app/alumno/programas/${programId}`}
          className="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-white mb-3"
        >
          <ChevronLeft className="w-4 h-4" aria-hidden="true" /> Volver al programa
        </Link>
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">
          {program.format} · {program.code}
        </p>
        <h1 className="mt-1 text-2xl md:text-3xl font-bold text-white font-display">
          {program.title}
        </h1>

        <nav className="mt-6 border-b border-gray-800 flex gap-1" data-testid="program-tabs">
          <Link
            to={`/app/alumno/programas/${programId}`}
            className="px-4 py-2 text-sm font-semibold border-b-2 border-transparent text-gray-400 hover:text-white"
          >
            Contenido
          </Link>
          <span className="px-4 py-2 text-sm font-semibold border-b-2 border-[#3B82F6] text-white">
            Foro
          </span>
        </nav>

        <div className="mt-6">
          <ProgramForum
            programSlug={program.slug}
            basePath={`/app/alumno/programas/${programId}`}
          />
        </div>
      </div>
    </AlumnoLayout>
  );
}
